import { inject, InjectionToken, Provider } from '@angular/core';

import { GridStackNode } from 'gridstack';
import { Observable } from 'rxjs';

import { AnyWidgetDef } from '@recruitee/dashboard-types';

const DASHBOARD_WIDGET_TOKEN = new InjectionToken<Observable<AnyWidgetDef>>(
  'DASHBOARD_WIDGET_TOKEN',
);
export const injectDashboardWidgets = () =>
  <Array<Observable<AnyWidgetDef>>>(<unknown>inject(DASHBOARD_WIDGET_TOKEN));
export const provideDashboardWidget = (widgetDef: Observable<AnyWidgetDef>): Provider => ({
  provide: DASHBOARD_WIDGET_TOKEN,
  useValue: widgetDef,
  multi: true,
});

export const gridstackMoveToTop = (node: GridStackNode) => {
  if (!node.grid) return;

  node.grid.setAnimation(false);
  node.grid.engine.moveNode(node, { x: 0, y: 0 });
  node.grid.setAnimation(true);
};
